// // // // // // // /*
// // // // // // //  * AUTH SERVICE - API calls commented out for frontend-only development
// // // // // // //  * Uncomment when backend is ready
// // // // // // //  */

// // // // // // // // import apiClient from '../client/axios.config';
// // // // // // // // import { API_ENDPOINTS } from '../endpoints';

// // // // // // // export const authService = {
// // // // // // //     // Mock login - validates specific credentials
// // // // // // //     login: async (credentials) => {
// // // // // // //         // Simulate API delay
// // // // // // //         await new Promise(resolve => setTimeout(resolve, 1000));

// // // // // // //         // Validate credentials
// // // // // // //         if (credentials.email === 'admin@gmail.com' && credentials.password === 'admin12345') {
// // // // // // //             return {
// // // // // // //                 token: 'mock-jwt-token-12345',
// // // // // // //                 user: {
// // // // // // //                     id: 1,
// // // // // // //                     name: 'Admin',
// // // // // // //                     email: credentials.email,
// // // // // // //                     role: 'admin',
// // // // // // //                     avatar: null,
// // // // // // //                 },
// // // // // // //             };
// // // // // // //         } else {
// // // // // // //             throw new Error('Invalid email or password');
// // // // // // //         }

// // // // // // //         /* ACTUAL API CALL - Uncomment when backend is ready:
// // // // // // //         return await apiClient.post(API_ENDPOINTS.AUTH.LOGIN, credentials);
// // // // // // //         */
// // // // // // //     },
// // // // // // //     logout: async () => {
// // // // // // //         await new Promise(resolve => setTimeout(resolve, 500));
// // // // // // //         return { success: true };

// // // // // // //         /* ACTUAL API CALL:
// // // // // // //         return await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT);
// // // // // // //         */
// // // // // // //     },

// // // // // // //     refreshToken: async () => {
// // // // // // //         return { token: 'mock-refreshed-token' };

// // // // // // //         /* ACTUAL API CALL:
// // // // // // //         return await apiClient.post(API_ENDPOINTS.AUTH.REFRESH);
// // // // // // //         */
// // // // // // //     },

// // // // // // //     forgotPassword: async (email) => {
// // // // // // //         await new Promise(resolve => setTimeout(resolve, 1000));
// // // // // // //         return { success: true, message: 'Password reset email sent' };

// // // // // // //         /* ACTUAL API CALL:
// // // // // // //         return await apiClient.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
// // // // // // //         */
// // // // // // //     },
// // // // // // // };
// // // // // // import apiClient from '../client/axios.config';
// // // // // // import { API_ENDPOINTS } from '../endpoints';

// // // // // // export const authService = {

// // // // // //     // Admin login — POST /login/admin/login
// // // // // //     login: async (credentials) => {
// // // // // //         const res = await apiClient.post(API_ENDPOINTS.AUTH.ADMIN_LOGIN, {
// // // // // //             email:    credentials.email,
// // // // // //             password: credentials.password,
// // // // // //         });

// // // // // //         const { accessToken, user } = res.data?.data || {};

// // // // // //         if (accessToken) {
// // // // // //             localStorage.setItem('authToken', accessToken);
// // // // // //             localStorage.setItem('authUser',  JSON.stringify(user));
// // // // // //         }

// // // // // //         return { token: accessToken, user };
// // // // // //     },

// // // // // //     // Logout — POST /login/logout
// // // // // //     logout: async () => {
// // // // // //         try {
// // // // // //             await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT);
// // // // // //         } catch (_) {
// // // // // //             // clear local state regardless
// // // // // //         } finally {
// // // // // //             localStorage.removeItem('authToken');
// // // // // //             localStorage.removeItem('authUser');
// // // // // //         }
// // // // // //         return { success: true };
// // // // // //     },

// // // // // //     // Refresh token — POST /login/refresh-token
// // // // // //     refreshToken: async () => {
// // // // // //         const res      = await apiClient.post(API_ENDPOINTS.AUTH.REFRESH);
// // // // // //         const newToken = res.data?.data?.accessToken;
// // // // // //         if (newToken) localStorage.setItem('authToken', newToken);
// // // // // //         return { token: newToken };
// // // // // //     },

// // // // // //     // Forgot password — POST /login/forgot-password
// // // // // //     forgotPassword: async (email) => {
// // // // // //         const res = await apiClient.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
// // // // // //         return res.data;
// // // // // //     },

// // // // // //     // Reset password — POST /login/reset-password
// // // // // //     resetPassword: async ({ token, password }) => {
// // // // // //         const res = await apiClient.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, { token, password });
// // // // // //         return res.data;
// // // // // //     },

// // // // // //     getCurrentUser: () => {
// // // // // //         try { return JSON.parse(localStorage.getItem('authUser')) || null; }
// // // // // //         catch { return null; }
// // // // // //     },

// // // // // //     isAuthenticated: () => !!localStorage.getItem('authToken'),
// // // // // // };
// // // // // import apiClient from '../client/axios.config';
// // // // // import { API_ENDPOINTS } from '../endpoints';

// // // // // export const authService = {
// // // // //     login: async (credentials) => {
// // // // //         let res;

// // // // //         if (credentials.role === 'admin') {
// // // // //             res = await apiClient.post(API_ENDPOINTS.AUTH.ADMIN_LOGIN, {
// // // // //                 email: credentials.email,
// // // // //                 password: credentials.password,
// // // // //             });
// // // // //         } else if (credentials.role === 'vendor' || credentials.role === 'referee') {
// // // // //             res = await apiClient.post(API_ENDPOINTS.AUTH.VENDOR_LOGIN, {
// // // // //                 username: credentials.username,
// // // // //                 password: credentials.password,
// // // // //             });
// // // // //         } else {
// // // // //             throw new Error('Unsupported login role');
// // // // //         }

// // // // //         const { accessToken, user, redirectTo } = res.data?.data || {};

// // // // //         if (accessToken) {
// // // // //             localStorage.setItem('authToken', accessToken);
// // // // //             localStorage.setItem('authUser', JSON.stringify(user));
// // // // //         }

// // // // //         return {
// // // // //             token: accessToken,
// // // // //             user,
// // // // //             redirectTo,
// // // // //             success: true,
// // // // //         };
// // // // //     },

// // // // //     logout: async () => {
// // // // //         try {
// // // // //             await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT);
// // // // //         } catch (_) {
// // // // //         } finally {
// // // // //             localStorage.removeItem('authToken');
// // // // //             localStorage.removeItem('authUser');
// // // // //         }

// // // // //         return { success: true };
// // // // //     },

// // // // //     refreshToken: async () => {
// // // // //         const res = await apiClient.post(API_ENDPOINTS.AUTH.REFRESH);
// // // // //         const newToken = res.data?.data?.accessToken;

// // // // //         if (newToken) {
// // // // //             localStorage.setItem('authToken', newToken);
// // // // //         }

// // // // //         return { token: newToken };
// // // // //     },

// // // // //     forgotPassword: async (email) => {
// // // // //         const res = await apiClient.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
// // // // //         return res.data;
// // // // //     },

// // // // //     resetPassword: async ({ token, password }) => {
// // // // //         const res = await apiClient.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, { token, password });
// // // // //         return res.data;
// // // // //     },

// // // // //     getCurrentUser: () => {
// // // // //         try {
// // // // //             return JSON.parse(localStorage.getItem('authUser')) || null;
// // // // //         } catch {
// // // // //             return null;
// // // // //         }
// // // // //     },

// // // // //     isAuthenticated: () => !!localStorage.getItem('authToken'),
// // // // // };
// // // // import apiClient from '../client/axios.config';
// // // // import { API_ENDPOINTS } from '../endpoints';

// // // // const setAuthStorage = ({ accessToken, user, permissions }) => {
// // // //   if (accessToken) {
// // // //     localStorage.setItem('authToken', accessToken);
// // // //   }

// // // //   if (user) {
// // // //     localStorage.setItem('authUser', JSON.stringify(user));
// // // //   }

// // // //   localStorage.setItem('authPermissions', JSON.stringify(permissions || {}));
// // // // };

// // // // const clearAuthStorage = () => {
// // // //   localStorage.removeItem('authToken');
// // // //   localStorage.removeItem('authUser');
// // // //   localStorage.removeItem('authPermissions');
// // // // };

// // // // export const authService = {
// // // //   login: async (credentials) => {
// // // //     let res;

// // // //     if (credentials.role === 'admin') {
// // // //       res = await apiClient.post(API_ENDPOINTS.AUTH.ADMIN_LOGIN, {
// // // //         email: credentials.email,
// // // //         password: credentials.password,
// // // //       });
// // // //     } else if (credentials.role === 'vendor' || credentials.role === 'referee') {
// // // //       res = await apiClient.post(API_ENDPOINTS.AUTH.VENDOR_LOGIN, {
// // // //         username: credentials.username,
// // // //         password: credentials.password,
// // // //       });
// // // //     } else if (credentials.role === 'customer') {
// // // //       res = await apiClient.post(API_ENDPOINTS.AUTH.LOGIN, {
// // // //         email: credentials.email,
// // // //         password: credentials.password,
// // // //       });
// // // //     } else {
// // // //       throw new Error('Unsupported login role');
// // // //     }

// // // //     const { accessToken, user, redirectTo, permissions } = res.data?.data || {};

// // // //     setAuthStorage({
// // // //       accessToken,
// // // //       user,
// // // //       permissions: permissions || {},
// // // //     });

// // // //     return {
// // // //       token: accessToken,
// // // //       user,
// // // //       permissions: permissions || {},
// // // //       redirectTo,
// // // //       success: true,
// // // //     };
// // // //   },

// // // //   logout: async () => {
// // // //     try {
// // // //       await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT);
// // // //     } catch (_) {
// // // //     } finally {
// // // //       clearAuthStorage();
// // // //     }

// // // //     return { success: true };
// // // //   },

// // // //   refreshToken: async () => {
// // // //     const res = await apiClient.post(API_ENDPOINTS.AUTH.REFRESH);
// // // //     const { accessToken, user, permissions } = res.data?.data || {};

// // // //     setAuthStorage({
// // // //       accessToken,
// // // //       user,
// // // //       permissions: permissions || {},
// // // //     });

// // // //     return {
// // // //       token: accessToken,
// // // //       user,
// // // //       permissions: permissions || {},
// // // //     };
// // // //   },

// // // //   forgotPassword: async (email) => {
// // // //     const res = await apiClient.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
// // // //     return res.data;
// // // //   },

// // // //   resetPassword: async ({ token, password }) => {
// // // //     const res = await apiClient.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, { token, password });
// // // //     return res.data;
// // // //   },

// // // //   getCurrentUser: () => {
// // // //     try {
// // // //       return JSON.parse(localStorage.getItem('authUser')) || null;
// // // //     } catch {
// // // //       return null;
// // // //     }
// // // //   },

// // // //   getPermissions: () => {
// // // //     try {
// // // //       return JSON.parse(localStorage.getItem('authPermissions')) || {};
// // // //     } catch {
// // // //       return {};
// // // //     }
// // // //   },

// // // //   getToken: () => localStorage.getItem('authToken') || null,

// // // //   isAuthenticated: () => !!localStorage.getItem('authToken'),
// // // // };
// // // import apiClient from '../client/axios.config';
// // // import { API_ENDPOINTS } from '../endpoints';

// // // const setAuthStorage = ({ accessToken, user, permissions }) => {
// // //   if (accessToken) {
// // //     localStorage.setItem('authToken', accessToken);
// // //   }

// // //   if (user) {
// // //     localStorage.setItem('authUser', JSON.stringify(user));
// // //   }

// // //   localStorage.setItem('authPermissions', JSON.stringify(permissions || {}));
// // // };

// // // const clearAuthStorage = () => {
// // //   localStorage.removeItem('authToken');
// // //   localStorage.removeItem('authUser');
// // //   localStorage.removeItem('authPermissions');
// // // };

// // // export const authService = {
// // //   login: async (credentials) => {
// // //     let res;

// // //     if (credentials.role === 'admin') {
// // //       res = await apiClient.post(API_ENDPOINTS.AUTH.ADMIN_LOGIN, {
// // //         email: credentials.email,
// // //         password: credentials.password,
// // //       });
// // //     } else if (credentials.role === 'vendor' || credentials.role === 'referee') {
// // //       res = await apiClient.post(API_ENDPOINTS.AUTH.VENDOR_LOGIN, {
// // //         username: credentials.username,
// // //         password: credentials.password,
// // //       });
// // //     } else if (credentials.role === 'customer') {
// // //       res = await apiClient.post(API_ENDPOINTS.AUTH.LOGIN, {
// // //         email: credentials.email,
// // //         password: credentials.password,
// // //       });
// // //     } else {
// // //       throw new Error('Unsupported login role');
// // //     }

// // //     const { accessToken, user, redirectTo, permissions } = res.data?.data || {};

// // //     setAuthStorage({
// // //       accessToken,
// // //       user,
// // //       permissions: permissions || {},
// // //     });

// // //     return {
// // //       token: accessToken,
// // //       user,
// // //       permissions: permissions || {},
// // //       redirectTo,
// // //       success: true,
// // //     };
// // //   },

// // //   logout: async () => {
// // //     try {
// // //       await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT);
// // //     } catch (_) {
// // //     } finally {
// // //       clearAuthStorage();
// // //     }

// // //     return { success: true };
// // //   },

// // //   refreshToken: async () => {
// // //     const res = await apiClient.post(API_ENDPOINTS.AUTH.REFRESH);
// // //     const { accessToken, user, permissions } = res.data?.data || {};

// // //     setAuthStorage({
// // //       accessToken,
// // //       user,
// // //       permissions: permissions || {},
// // //     });

// // //     return {
// // //       token: accessToken,
// // //       user,
// // //       permissions: permissions || {},
// // //     };
// // //   },

// // //   forgotPassword: async (email) => {
// // //     const res = await apiClient.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
// // //     return res.data;
// // //   },

// // //   resetPassword: async ({ token, password }) => {
// // //     const res = await apiClient.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, { token, password });
// // //     return res.data;
// // //   },

// // //   // NEW: fetch users, optionally filtered by role
// // //   getUsersByRole: async (role) => {
// // //     const res = await apiClient.get('/login/users', {
// // //       params: role ? { role } : {},
// // //     });
// // //     return res.data;
// // //   },

// // //   getCurrentUser: () => {
// // //     try {
// // //       return JSON.parse(localStorage.getItem('authUser')) || null;
// // //     } catch {
// // //       return null;
// // //     }
// // //   },

// // //   getPermissions: () => {
// // //     try {
// // //       return JSON.parse(localStorage.getItem('authPermissions')) || {};
// // //     } catch {
// // //       return {};
// // //     }
// // //   },

// // //   getToken: () => localStorage.getItem('authToken') || null,

// // //   isAuthenticated: () => !!localStorage.getItem('authToken'),
// // // };
// // import apiClient from '../client/axios.config';
// // import { API_ENDPOINTS } from '../endpoints';

// // const USERNAME_LOGIN_ROLES = ['vendor', 'referee', 'coach', 'player'];

// // const setAuthStorage = ({ accessToken, user, permissions }) => {
// //   if (accessToken) {
// //     localStorage.setItem('authToken', accessToken);
// //   }

// //   if (user) {
// //     localStorage.setItem('authUser', JSON.stringify(user));
// //   }

// //   localStorage.setItem('authPermissions', JSON.stringify(permissions || {}));
// // };

// // const clearAuthStorage = () => {
// //   localStorage.removeItem('authToken');
// //   localStorage.removeItem('authUser');
// //   localStorage.removeItem('authPermissions');
// // };

// // export const authService = {
// //   login: async (credentials) => {
// //     const role = String(credentials?.role || '').trim().toLowerCase();
// //     let res;

// //     if (role === 'admin') {
// //       res = await apiClient.post(API_ENDPOINTS.AUTH.ADMIN_LOGIN, {
// //         email: String(credentials?.email || '').trim().toLowerCase(),
// //         password: credentials?.password || '',
// //       });
// //     } else {
// //       // customer, vendor, referee, coach, player — all use email+password now
// //       res = await apiClient.post(API_ENDPOINTS.AUTH.LOGIN, {
// //         email: String(credentials?.email || '').trim().toLowerCase(),
// //         password: credentials?.password || '',
// //       });
// //     }

// //     const { accessToken, user, redirectTo, permissions } = res.data?.data || {};

// //     setAuthStorage({
// //       accessToken,
// //       user,
// //       permissions: permissions || {},
// //     });

// //     return {
// //       token: accessToken,
// //       user,
// //       permissions: permissions || {},
// //       redirectTo,
// //       success: true,
// //     };
// //   },

// //   logout: async () => {
// //     try {
// //       await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT);
// //     } catch (_) {
// //     } finally {
// //       clearAuthStorage();
// //     }

// //     return { success: true };
// //   },

// //   refreshToken: async () => {
// //     const res = await apiClient.post(API_ENDPOINTS.AUTH.REFRESH);
// //     const { accessToken, user, permissions } = res.data?.data || {};

// //     setAuthStorage({
// //       accessToken,
// //       user,
// //       permissions: permissions || {},
// //     });

// //     return {
// //       token: accessToken,
// //       user,
// //       permissions: permissions || {},
// //     };
// //   },

// //   forgotPassword: async (email) => {
// //     const res = await apiClient.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
// //     return res.data;
// //   },

// //    changePassword: async ({ currentPassword, newPassword, confirmPassword }) => {
// //     const res = await apiClient.patch(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, {
// //       currentPassword,
// //       newPassword,
// //       confirmPassword: confirmPassword ?? newPassword,
// //     });
// //     return res.data;
// //   },

// //   resetPassword: async ({ token, password }) => {
// //     const res = await apiClient.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, { token, password });
// //     return res.data;
// //   },

// //   getUsersByRole: async (role) => {
// //     const res = await apiClient.get(API_ENDPOINTS.AUTH.GET_USERS, {
// //       params: role ? { role } : {},
// //     });
// //     return res.data;
// //   },

// //   getCurrentUser: () => {
// //     try {
// //       return JSON.parse(localStorage.getItem('authUser')) || null;
// //     } catch {
// //       return null;
// //     }
// //   },

// //   getPermissions: () => {
// //     try {
// //       return JSON.parse(localStorage.getItem('authPermissions')) || {};
// //     } catch {
// //       return {};
// //     }
// //   },

// //   getToken: () => localStorage.getItem('authToken') || null,

// //   isAuthenticated: () => !!localStorage.getItem('authToken'),
// // };
// import apiClient from '../client/axios.config';
// import { API_ENDPOINTS } from '../endpoints';

// const USERNAME_LOGIN_ROLES = ['vendor', 'referee', 'coach', 'player'];

// const setAuthStorage = ({ accessToken, user, permissions }) => {
//   if (accessToken) {
//     localStorage.setItem('authToken', accessToken);
//   }

//   if (user) {
//     localStorage.setItem('authUser', JSON.stringify(user));
//   }

//   localStorage.setItem('authPermissions', JSON.stringify(permissions || {}));
// };

// const clearAuthStorage = () => {
//   localStorage.removeItem('authToken');
//   localStorage.removeItem('authUser');
//   localStorage.removeItem('authPermissions');
// };

// export const authService = {
//   login: async (credentials) => {
//     const role = String(credentials?.role || '').trim().toLowerCase();
//     let res;

//     if (role === 'admin') {
//       res = await apiClient.post(API_ENDPOINTS.AUTH.ADMIN_LOGIN, {
//         email: String(credentials?.email || '').trim().toLowerCase(),
//         password: credentials?.password || '',
//       });
//     } else {
//       // customer, vendor, referee, coach, player — all use email+password now
//       res = await apiClient.post(API_ENDPOINTS.AUTH.LOGIN, {
//         email: String(credentials?.email || '').trim().toLowerCase(),
//         password: credentials?.password || '',
//       });
//     }

//     const { accessToken, user, redirectTo, permissions } = res.data?.data || {};

//     setAuthStorage({
//       accessToken,
//       user,
//       permissions: permissions || {},
//     });

//     return {
//       token: accessToken,
//       user,
//       permissions: permissions || {},
//       redirectTo,
//       success: true,
//     };
//   },

//   logout: async () => {
//     try {
//       await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT);
//     } catch (_) {
//     } finally {
//       clearAuthStorage();
//     }

//     return { success: true };
//   },

//   refreshToken: async () => {
//     const res = await apiClient.post(API_ENDPOINTS.AUTH.REFRESH);
//     const { accessToken, user, permissions } = res.data?.data || {};

//     setAuthStorage({
//       accessToken,
//       user,
//       permissions: permissions || {},
//     });

//     return {
//       token: accessToken,
//       user,
//       permissions: permissions || {},
//     };
//   },

//   forgotPassword: async (email) => {
//     const res = await apiClient.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
//     return res.data;
//   },

//   resetPassword: async ({ token, password }) => {
//     const res = await apiClient.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, { token, password });
//     return res.data;
//   },

//   // NEW — changes the logged-in user's password. Requires the caller to be
//   // authenticated; apiClient's request interceptor is expected to attach
//   // the Authorization: Bearer <authToken> header the same way it does for
//   // every other authenticated call (coachService, sportService, etc).
//   //
//   // Backend contract (authController.changePassword), per routes/auth.js:
//   //   PATCH API_ENDPOINTS.AUTH.CHANGE_PASSWORD  →  /login/me/change-password
//   //   protected by `authenticate` middleware
//   //   body: { currentPassword, newPassword, confirmPassword }
//   //   - all three fields are required
//   //   - newPassword must be >= 8 characters
//   //   - newPassword must equal confirmPassword (checked server-side too)
//   //   - on success, ALL of the user's refresh tokens are invalidated, so
//   //     the caller should log the user out / redirect to login afterwards.
//   //
//   // A wrong current password returns 401 with a normal business message
//   // ("Current password is incorrect") — that is NOT a session-expiry
//   // signal, so this call passes `skipAuthRefresh: true` (also matched by
//   // path in axios.config.js's AUTH_ACTION_ROUTES_SKIP_REFRESH as a second
//   // safeguard) to stop apiClient's interceptor from silently refreshing
//   // the token / force-logging-out on that 401.
//   //
//   // Any failure here is re-thrown as a plain Error whose `.message` is
//   // always the real backend message when available, so callers can simply
//   // do `catch (err) { setError(err.message) }` without needing to know
//   // whether apiClient rejected with a full axios error or an already
//   //-unwrapped response body.
//   changePassword: async ({ currentPassword, newPassword, confirmPassword }) => {
//     try {
//       const res = await apiClient.patch(
//         API_ENDPOINTS.AUTH.CHANGE_PASSWORD,
//         {
//           currentPassword,
//           newPassword,
//           confirmPassword: confirmPassword ?? newPassword,
//         },
//         { skipAuthRefresh: true }
//       );
//       return res.data;
//     } catch (err) {
//       const message =
//         err?.response?.data?.message ||
//         err?.message ||
//         'Failed to change password. Please try again.';
//       const normalizedError = new Error(message);
//       normalizedError.original = err;
//       normalizedError.status = err?.response?.status || err?.status;
//       throw normalizedError;
//     }
//   },

//   getUsersByRole: async (role) => {
//     const res = await apiClient.get(API_ENDPOINTS.AUTH.GET_USERS, {
//       params: role ? { role } : {},
//     });
//     return res.data;
//   },

//   getCurrentUser: () => {
//     try {
//       return JSON.parse(localStorage.getItem('authUser')) || null;
//     } catch {
//       return null;
//     }
//   },

//   getPermissions: () => {
//     try {
//       return JSON.parse(localStorage.getItem('authPermissions')) || {};
//     } catch {
//       return {};
//     }
//   },

//   getToken: () => localStorage.getItem('authToken') || null,

//   isAuthenticated: () => !!localStorage.getItem('authToken'),
// };
import apiClient from '../client/axios.config';
import { API_ENDPOINTS } from '../endpoints';

const USERNAME_LOGIN_ROLES = ['vendor', 'referee', 'coach', 'player'];

const setAuthStorage = ({ accessToken, user, permissions }) => {
  if (accessToken) {
    localStorage.setItem('authToken', accessToken);
  }

  if (user) {
    localStorage.setItem('authUser', JSON.stringify(user));
  }

  localStorage.setItem('authPermissions', JSON.stringify(permissions || {}));
};

const clearAuthStorage = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('authUser');
  localStorage.removeItem('authPermissions');
};

// NEW — extracts a user-facing message from an apiClient error, no matter
// which shape it arrives in:
//   1. A full axios error: err.response.data = { success, message, errors? }
//   2. apiClient's interceptor already-unwrapped body: err = { success, message, errors? }
//   3. A plain axios/network error with no response: err.message
//
// Crucially, when the backend responds with express-validator's shape —
//   { success: false, message: 'Validation failed', errors: [{ msg, path, ... }] }
// — the top-level `message` ("Validation failed") is just a generic
// wrapper. The actually useful text is inside `errors[].msg` (e.g.
// "New password must be at least 8 characters"), so this prefers that
// over the generic wrapper whenever field-level errors are present.
const extractErrorMessage = (err, fallback = 'Something went wrong. Please try again.') => {
  const data = err?.response?.data || err;

  const fieldErrors = Array.isArray(data?.errors) ? data.errors : null;
  if (fieldErrors && fieldErrors.length > 0) {
    const messages = fieldErrors
      .map((e) => e?.msg || e?.message)
      .filter(Boolean);
    if (messages.length) return messages.join(' ');
  }

  return data?.message || err?.message || fallback;
};

export const authService = {
  // login: async (credentials) => {
  //   const role = String(credentials?.role || '').trim().toLowerCase();
  //   let res;

  //   if (role === 'admin') {
  //     res = await apiClient.post(API_ENDPOINTS.AUTH.ADMIN_LOGIN, {
  //       email: String(credentials?.email || '').trim().toLowerCase(),
  //       password: credentials?.password || '',
  //     });
  //   } else {
  //     // customer, vendor, referee, coach, player — all use email+password now
  //     res = await apiClient.post(API_ENDPOINTS.AUTH.LOGIN, {
  //       email: String(credentials?.email || '').trim().toLowerCase(),
  //       password: credentials?.password || '',
  //     });
  //   }

  //   const { accessToken, user, redirectTo, permissions } = res.data?.data || {};

  //   setAuthStorage({
  //     accessToken,
  //     user,
  //     permissions: permissions || {},
  //   });

  //   return {
  //     token: accessToken,
  //     user,
  //     permissions: permissions || {},
  //     redirectTo,
  //     success: true,
  //   };
  // },
  login: async (credentials) => {
  const role = String(credentials?.role || '').trim().toLowerCase();

  try {
    let res;

    if (role === 'admin') {
      res = await apiClient.post(API_ENDPOINTS.AUTH.ADMIN_LOGIN, {
        email: String(credentials?.email || '').trim().toLowerCase(),
        password: credentials?.password || '',
      });
    } else {
      res = await apiClient.post(
        API_ENDPOINTS.AUTH.LOGIN,
        {
          email: String(credentials?.email || '').trim().toLowerCase(),
          password: credentials?.password || '',
        },
        { skipAuthRefresh: true }
      );
    }

    const { accessToken, user, redirectTo, permissions } = res.data?.data || {};

    setAuthStorage({
      accessToken,
      user,
      permissions: permissions || {},
    });

    return {
      token: accessToken,
      user,
      permissions: permissions || {},
      redirectTo,
      success: true,
    };
  } catch (err) {
    const message = extractErrorMessage(err, 'Invalid credentials. Please check your email and password.');
    const status = err?.status ?? err?.response?.status;

    const normalizedError = new Error(message);
    normalizedError.original = err;
    normalizedError.status = status;
    normalizedError.data = err?.data ?? err?.response?.data;
    throw normalizedError;
  }
},

  logout: async () => {
    try {
      await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT);
    } catch (_) {
    } finally {
      clearAuthStorage();
    }

    return { success: true };
  },

  refreshToken: async () => {
    const res = await apiClient.post(API_ENDPOINTS.AUTH.REFRESH);
    const { accessToken, user, permissions } = res.data?.data || {};

    setAuthStorage({
      accessToken,
      user,
      permissions: permissions || {},
    });

    return {
      token: accessToken,
      user,
      permissions: permissions || {},
    };
  },

  forgotPassword: async (email) => {
    const res = await apiClient.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
    return res.data;
  },

  resetPassword: async ({ token, password }) => {
    const res = await apiClient.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, { token, password });
    return res.data;
  },

  // NEW — changes the logged-in user's password. Requires the caller to be
  // authenticated; apiClient's request interceptor is expected to attach
  // the Authorization: Bearer <authToken> header the same way it does for
  // every other authenticated call (coachService, sportService, etc).
  //
  // Backend contract (authController.changePassword), per routes/auth.js:
  //   PATCH API_ENDPOINTS.AUTH.CHANGE_PASSWORD  →  /login/me/change-password
  //   protected by `authenticate` middleware
  //   body: { currentPassword, newPassword, confirmPassword }
  //   - all three fields are required
  //   - newPassword must be >= 8 characters
  //   - newPassword must equal confirmPassword (checked server-side too)
  //   - on success, ALL of the user's refresh tokens are invalidated, so
  //     the caller should log the user out / redirect to login afterwards.
  //
  // A wrong current password returns 401 with a normal business message
  // ("Current password is incorrect") — that is NOT a session-expiry
  // signal, so this call passes `skipAuthRefresh: true` (also matched by
  // path in axios.config.js's AUTH_ACTION_ROUTES_SKIP_REFRESH as a second
  // safeguard) to stop apiClient's interceptor from silently refreshing
  // the token / force-logging-out on that 401.
  //
  // Any failure here is re-thrown as a plain Error whose `.message` is
  // always the real backend message when available, so callers can simply
  // do `catch (err) { setError(err.message) }` without needing to know
  // whether apiClient rejected with a full axios error or an already
  //-unwrapped response body.
  changePassword: async ({ currentPassword, newPassword, confirmPassword }) => {
    try {
      const res = await apiClient.patch(
        API_ENDPOINTS.AUTH.CHANGE_PASSWORD,
        {
          currentPassword,
          newPassword,
          confirmPassword: confirmPassword ?? newPassword,
        },
        { skipAuthRefresh: true }
      );
      return res.data;
    } catch (err) {
      const message = extractErrorMessage(err, 'Failed to change password. Please try again.');
      const normalizedError = new Error(message);
      normalizedError.original = err;
      normalizedError.status = err?.response?.status || err?.status;
      throw normalizedError;
    }
  },

  getUsersByRole: async (role) => {
    const res = await apiClient.get(API_ENDPOINTS.AUTH.GET_USERS, {
      params: role ? { role } : {},
    });
    return res.data;
  },

  getCurrentUser: () => {
    try {
      return JSON.parse(localStorage.getItem('authUser')) || null;
    } catch {
      return null;
    }
  },

  getPermissions: () => {
    try {
      return JSON.parse(localStorage.getItem('authPermissions')) || {};
    } catch {
      return {};
    }
  },

  getToken: () => localStorage.getItem('authToken') || null,

  isAuthenticated: () => !!localStorage.getItem('authToken'),
};